import { createContext } from "react"

import { Purpose, PurposesState, SellerType } from "@/models"

export type PurposesContextValue = {
  purposes: Purpose[]
  purposeState: PurposesState
  sellerType: SellerType
  getPurposes: () => Promise<Purpose[]>
  checkValidPurpose: (documentPurposeType: string) => Promise<boolean>
}

export const PurposesContext = createContext({} as PurposesContextValue)
